import React, { useEffect, useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate, useParams } from 'react-router-dom';
import dietService from '../../services/diet_service';

function UpdateDiet() {
  const [name, setName] = useState([]);
  const [menuRows, setMenuRows] = useState([]);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await dietService.getOneDietClass(id);
        const dietMenusResponse = await dietService.getAllDietClassMenus();
        const relatedMenus = dietMenusResponse.data.filter(menu => menu.diet_class_id === result.data.id);
        setName(result.data.name)
        setMenuRows(relatedMenus)
      }
      catch (e){
        console.log(e)
      }
    };

    fetchData();
  }, []);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleMenuRowsChange = (index, event) => {
    const newMenuRows = [...menuRows];
    newMenuRows[index][event.target.name] = event.target.value;
    setMenuRows(newMenuRows);
  };

  const handleAddRow = () => {
    setMenuRows([...menuRows, { menu_name: "", calories: 0 }]);
  };

  const handleRemoveRow = (index) => {
    setMenuRows(menuRows.filter((_, idx) => idx !== index));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const deleteMenusOnClasses = await dietService.deleteClasses(id);
    const dietData = {
      diet_class_menus: menuRows,
    };
    const data = await Promise.all(dietData.diet_class_menus.map( async menu => {
      const params = {
        name:menu.menu_name??menu.name,
        calories:menu.calories,
        diet_class_id:id
      }
      return dietService.createOneMenu(params)
    }))
    navigate(-1)
  };

  return (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen Diet" />
      </Box>
      <Box sx={{ marginLeft:'280px', marginRight:'50px', p: 2 }}>
        <form onSubmit={handleSubmit}>

          {/* Input Name */}
          <Box sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
            <TextField
              required
              fullWidth
              label="Name"
              value={name}
              onChange={handleNameChange}
              variant="outlined" />
          </Box>

          {/* Menu Rows */}
          {menuRows && menuRows.map((menuRow, index) => (
            <Box key={index} sx={{ mb: 2, backgroundColor: 'white', boxShadow: 3 }}>
              <TextField
                required
                name="menu_name"
                label="Menu Name"
                value={menuRow.name}
                onChange={(event) => handleMenuRowsChange(index, event)}
                variant="outlined"
              />
              <TextField
                required
                type="number"
                name="calories"
                label="Calories"
                value={menuRow.calories}
                onChange={(event) => handleMenuRowsChange(index, event)}
                variant="outlined"
              />
              <Button onClick={() => handleRemoveRow(index)}>Delete Row</Button>
            </Box>
          ))}

          <Button onClick={handleAddRow}>Add Row</Button>

          {/* Buttons */}
          <Box sx={{ mt: 2, mb: 5 }}>
            <Button variant="contained" color="primary" type="submit" onClick={handleSubmit}>Update</Button>
            <Button variant="contained" color="error" onClick={handleCancel}>Cancel</Button>
          </Box>

        </form>
      </Box>
    </>
  );
}

export default UpdateDiet;
